import { IRequestContext } from '@msdyn365-commerce/core';
import { useCallback, useEffect } from 'react';
import {
    checkIfServiceConsentIsGiven,
    hasUCUILoaded,
    removeCookieFromContext,
    setCookieFromRequest
} from '../../../shared/functions/cookie';
import { TEMPORARY_USER_ID_COOKIE_NAME } from '../services/UserService';

export const useSetTemporaryUserIdCookie = (request: IRequestContext) => {
    const setTemporaryUserIdCookie = useCallback(async () => {
        if (!hasUCUILoaded(window)) {
            return;
        }

        const hasConsented = await checkIfServiceConsentIsGiven('Relewise');
        const controllerId = window.UC_UI.getControllerId();

        if (hasConsented && controllerId) {
            setCookieFromRequest(TEMPORARY_USER_ID_COOKIE_NAME, controllerId, request);
        } else if (!hasConsented) {
            removeCookieFromContext(TEMPORARY_USER_ID_COOKIE_NAME, request);
        }
    }, [request]);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        setTemporaryUserIdCookie();

        window.addEventListener('ucEvent', setTemporaryUserIdCookie);
        return () => {
            window.removeEventListener('ucEvent', setTemporaryUserIdCookie);
        };
    }, [setTemporaryUserIdCookie]);
};
